export const IS_3D_VIEWER_ENABLED =
  process.env.NEXT_PUBLIC_3D_VIEWER_ENABLED === 'true';

/**
 * Maps watch SKUs to their corresponding 3D model names.
 * Model files are located in /public/3d-assets/.
 * Managed as part of BEC-21743 (3D viewer POC).
 */
export const SKU_TO_3D_MODEL: Record<string, string> = {
  A32398101L1A1: 'Chronomat_Automatic_GMT_40',
  AB0147101L1X1: 'Avenger_Chronograph_44',
  AB0138241K1P1: 'Navitimer_Chronograph_43',
};
